import { useCallback } from 'react';

const WHATSAPP_URL = 'https://wa.me/5511984095840?text=Ol%C3%A1%2C%20gostaria%20de%20avaliar%20meu%20caso.';

export default function HeroSection() {
  const scrollToForm = useCallback(() => {
    const el = document.getElementById('cta');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <section id="hero" className="relative w-full h-screen min-h-[600px] overflow-hidden" style={{ backgroundColor: '#0e1410' }}>
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-green/20 via-transparent to-brand-gold/5" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-8 w-full">
        <div className="max-w-4xl w-full mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 border border-brand-gold/50 text-brand-gold text-xs font-sans font-medium tracking-widest uppercase px-4 py-2 rounded-full mb-8">
            <i className="ri-shield-check-line text-sm" />
            Direito Trabalhista Especializado
          </div>

          {/* Headline */}
          <h1 className="font-serif text-white leading-tight mb-6">
            <span className="block text-3xl md:text-5xl lg:text-6xl font-normal opacity-90">
              Você sofreu um acidente de trabalho
            </span>
            <span className="block text-4xl md:text-6xl lg:text-7xl font-bold text-brand-gold mt-1">
              ou doença ocupacional?
            </span>
          </h1>

          {/* Sub */}
          <p className="font-sans text-white/70 text-base md:text-xl font-light leading-relaxed max-w-2xl mx-auto mb-10">
            Saiba seus direitos e receba a indenização que você merece. Atendimento especializado e humanizado em São Paulo.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-2 bg-brand-gold text-brand-black font-sans font-semibold text-base px-8 py-4 rounded-full hover:bg-white hover:text-brand-black transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg" />
              Falar no WhatsApp
            </a>
            <button
              onClick={scrollToForm}
              className="flex items-center gap-2 border-2 border-white/70 text-white font-sans font-medium text-base px-8 py-4 rounded-full hover:border-brand-gold hover:text-brand-gold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-search-line text-lg" />
              Avaliar meu caso
            </button>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 right-8 z-10 hidden md:flex flex-col items-center gap-2">
        <span className="text-white/40 text-xs font-sans tracking-widest uppercase rotate-90 origin-center">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
